import type { BranchCategory } from '@festina/configuration-general-types/configuration'
import type { Optional } from '@festina-life/core'
import type { IconName } from '@festina-life/ui/structure'

export const CategoryToIconMap: Record<BranchCategory, Optional<IconName>> = {
  none: 'QuestionMarkCircle',
  main: 'Star',
  feature: 'CodeBracket',
  release: 'RocketLaunch',
}
